import { actionCreators as navigateActions } from './reducers/Navigation';
import { actionCreators as authActions } from './reducers/Auth';
import { actionCreators as taskActions } from './reducers/Task';
import { actionCreators as layoutActions } from './reducers/Layout';
import { actionCreators as clientActions } from './reducers/Client';
import { actionCreators as performanceCommentActions } from './reducers/PerformanceComment';
import { actionCreators as companyActions } from './reducers/Company';
import { actionCreators as phoneNumberTypeActions } from './reducers/PhoneNumberType';
import { actionCreators as projectActions } from './reducers/Project';
import { actionCreators as projectStaffingActions } from './reducers/ProjectStaffing';
import { actionCreators as landmanActions } from './reducers/Landman';
import { actionCreators as userActions } from './reducers/User';
import { actionCreators as officeActions } from './reducers/Office';
import { actionCreators as profileActions } from './reducers/Profile';
import { actionCreators as stateActions } from './reducers/State';
import { actionCreators as tractActions } from './reducers/Tract';
import { actionCreators as searchActions } from './reducers/Search';
import { actionCreators as ownerActions } from './reducers/Owner';
import { actionCreators as countyActions } from './reducers/County';
import { actionCreators as leaseholdActions } from './reducers/Leasehold';
import { actionCreators as fileManagementActions } from './reducers/FileManagement';
import { actionCreators as clauseActions } from './reducers/Clause';
import { actionCreators as leaseGenerationActions } from './reducers/LeaseGeneration';
import { actionCreators as feedbackActions } from './reducers/Feedback';
import { actionCreators as ownershipContactCategoriesActions } from './reducers/OwnershipContactCategories';
import { actionCreators as documentTemplateActions } from './reducers/DocumentTemplates';
import { actionCreators as tags } from './reducers/Tag';
import { actionCreators as cloneActions } from './reducers/Clone';
import { actionCreators as invoiceActions } from './reducers/Invoice';
import { actionCreators as personnelActions } from './reducers/Personnel';

export default {
    auth: { ...authActions },
    navigation: { ...navigateActions },
    task: { ...taskActions },
    layout: { ...layoutActions },
    client: { ...clientActions },
    company: { ...companyActions },
    performanceComment: { ...performanceCommentActions },
    phoneNumberType: { ...phoneNumberTypeActions },
    project: { ...projectActions },
    projectStaffing: { ...projectStaffingActions },
    landman: { ...landmanActions },
    user: { ...userActions },
    office: { ...officeActions },
    profile: { ...profileActions },
    state: { ...stateActions },
    tract: { ...tractActions },
    search: { ...searchActions },
    owner: { ...ownerActions },
    county: { ...countyActions },
    leasehold: { ...leaseholdActions },
    fileManagement: { ...fileManagementActions },
    clause: { ...clauseActions },
    leaseGeneration: { ...leaseGenerationActions },
    feedback: { ...feedbackActions },
    ownershipContactCategories: { ...ownershipContactCategoriesActions },
    documentTemplates: { ...documentTemplateActions },
    tags: { ...tags },
    clone: { ...cloneActions },
    invoice: { ...invoiceActions },
    personnel: { ...personnelActions },
};



// WEBPACK FOOTER //
// ./src/actions.ts